<template>
    <div class="logistics">
        <div class="layer">
            <Search />
        </div>
        <div style="background:#1d90d0">
            <div class="layer">
                <SuperNav theme="blue"/>
            </div>
        </div>
        <div class="layer">
            <div class="title">物流信息</div>
            <div class="ship_title">{{shipData.shipping_name}}:{{shipData.nu}}</div>
        </div>
        <div class="layer step">
            <el-steps :active="4">
                <el-step title="待揽件" icon="el-icon-edit" class="package"></el-step>
                <el-step v-if="shipData.state === 0 || shipData.state >= 3" title="在途" icon="el-icon-upload" class="transport"></el-step>
                <el-step v-if="shipData.state >= 3" title="派送中" icon="el-icon-picture" class="deliver"></el-step>
                <el-step v-if="shipData.state === 3" title="已签收" icon="el-icon-picture" class="signFor"></el-step>
            </el-steps>
            <div class="title mt30">{{orderState.get(+shipData.state)}}</div>
            <div class="detail">
                <div class="right" v-for="(item,index) in shipData.data" :key="index">
                    <div class="f14 fb">{{ item.date}}</div>
                    <div class="information">
                        <div class="info pr" >{{ item.today}}&emsp;【{{item.status}}】&emsp; {{ item.context }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Search from '@/components/Search/index'
import SuperNav from '@/components/SuperNav/index'
import { OrderService } from '../../../../service/order.service';
import { formatDateDate, formatDateTime} from '@/utils/formatDate'

const orderState = new Map([
    [0, '在途'],
    [1, '揽收'],
    [2, '疑难'],
    [3, '签收'],
    [4, '退签'],
    [5, '派件'],
    [6, '退回'],
    [7, '转单'],
    [10, '待清关'],
    [11, '清关中'],
    [12, '已清关'],
    [13, '清关异常'],
    [14, '收件人拒签'],
]);
export default {
    components: {Search,SuperNav},
    data() {
        return {
            orderState,
            list: [{
                time: '1000000000',
                sub:[{
                    time: '1000000000',
                    msg: '订单已下单'
                }]
            },{
                time: '1000000001',
                sub:[{
                    time: '1000000001',
                    msg: '商品已出库'
                }]

            },{
                time: '1000000002',
                sub: [{
                    time: '1000000002',
                    msg: 'XX已揽件'
                },{
                    time: '1000000003',
                    msg: '已经到达XX'
                }]
            }],
            shipData: {
                data: [],
            },
        }
    },
    filters: {
        formatDateTitle : formatDateDate,
        formatDateDetail : formatDateTime
    },
    async created() {
        this.shipData = await OrderService.queryShipping(this.$route.query.order_sn);
        this.shipData.state = +this.shipData.state;
        this.shipData.data.map(item => {
            item.date = item.time.split(' ')[0];
            item.today = item.time.split(' ')[1];
        });
        console.log(this.shipData);
    }
}
</script>

<style lang="scss" scoped>

    .ship_title {
        font-size: 16px;
        padding: 16px;
    }
    .title{
        font-size: 15px;
        font-weight: 700;
        margin-top: 70px;
        text-indent: 2em;
        border-bottom: 1px solid #e3e2e1;
        padding-bottom: 8px;
    }
    .step{
        padding: 0 80px;
        width: 1040px;
        margin-top: 50px;
    }
    .detail{
        line-height: 40px;
        .right{
            display: flex;
            padding-left: 50px;
            .information{
                margin-left: 30px;
                .info::before{
                    position: absolute;
                    left: -167px;
                    content: "";
                    width: 5px;
                    height: 5px;
                    border-radius: 7px;
                    background: #bab9b9;
                    top: 50%;
                    margin-top: -4px;
                    padding: 2px;
                    border: 2px solid #fff;
                }
                .info::after{
                    position: absolute;
                    left: -162px;
                    height: 38px;
                    width: 2px;
                    background: #bab9b9;
                    content: "";
                    top: 30px;
                }
                
            }
        }
        .right:last-child{
            .info:last-child:before{
                background: #1d90d0;
            }
            .info::after{
                background: #1d90d0;
            }
            .info:last-child::after{
                width: 0;
            }
        }
    }
</style>

<style lang="scss">
    .logistics{
        .el-step__head{
            .el-step__icon.is-icon{
                background: url('../../../../assets/images/icon/package.png') center center no-repeat;
                width: 64px;
                height: 64px;
                border-radius: 64px;
                top: 50%;
                margin-top: -32px;
            }
            .el-step__icon-inner{
                font-size: 0!important;
            } 
        }
        .el-step__main{
            .el-step__title{
                margin-left: 10px;
                margin-top: 8px;
            }
        }
        .el-step__head.is-finish{
          .el-step__icon.is-icon{
                background: url('../../../../assets/images/icon/packageC.png') center center no-repeat;
          }
        }
        .transport{
            .el-step__head{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/transport.png') center center no-repeat;
                }
            }
            .el-step__head.is-finish{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/transportC.png') center center no-repeat;
                }
            }
        }
        .deliver{
            .el-step__head{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/deliver.png') center center no-repeat;
                }
            }
            .el-step__head.is-finish{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/deliverC.png') center center no-repeat;
                }
            }
        }
        .signFor{
            .el-step__head{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/signFor.png') center center no-repeat;
                }
            }
            .el-step__head.is-finish{
                .el-step__icon.is-icon{
                    background: url('../../../../assets/images/icon/signForC.png') center center no-repeat;
                }
            }
        }
    }
</style>